import Eyebrow from "@/components/zeblan/Eyebrow";
import Reveal from "@/components/zeblan/Reveal";
import { ArrowRight } from "lucide-react";

export default function Contact({ onOpenLead }) {
  const cards = [
    { n: "01", title: "Contact us", body: "Reach out and we'll get right back to you.", type: "contact" },
    { n: "02", title: "Drop us a line", body: "Explain your problem in 3 sentences. An engineer will revert with a preliminary technical blueprint and feasibility study.", type: "drop-a-line" },
    { n: "03", title: "Free ROI assessment", body: "Schedule a session and we'll estimate the hours and money an AI agent could save you.", type: "roi-assessment" },
  ];

  return (
    <section id="contact" className="relative bg-white py-24 lg:py-32 border-t border-mist">
      <div
        aria-hidden
        className="absolute top-0 left-1/2 -translate-x-1/2 w-[760px] h-[420px] rounded-full opacity-30 blur-3xl pointer-events-none"
        style={{ background: "radial-gradient(closest-side, rgba(37,99,235,0.18), transparent 70%)" }}
      />

      <div className="relative max-w-5xl mx-auto px-6 lg:px-10 text-center">
        <Reveal>
          <div className="flex justify-center">
            <Eyebrow>Let's Talk</Eyebrow>
          </div>
          <h2 className="mt-6 text-navy font-extrabold tracking-tightish mx-auto max-w-3xl" style={{ fontSize: "clamp(30px,4vw,46px)" }}>
            Let's sit down, have a coffee, and figure out how AI can{" "}
            <span className="font-display italic font-medium text-blue">actually help</span> your business grow.
          </h2>
          <p className="mt-5 text-slate max-w-xl mx-auto text-[16px] leading-relaxed">
            Three easy ways to start the conversation. Pick whichever suits you.
          </p>
        </Reveal>

        <div className="mt-12 grid md:grid-cols-3 gap-5 text-left">
          {cards.map((c, i) => (
            <Reveal key={c.n} delay={i * 100}>
              <button
                type="button"
                onClick={() => onOpenLead(c.type)}
                className="group w-full h-full bg-white hover:bg-cloud border border-mist hover:border-blue rounded-2xl p-7 text-left transition-all hover:-translate-y-1 hover:shadow-[0_18px_40px_-22px_rgba(10,19,40,0.22)]"
                data-testid={`contact-card-${c.type}`}
              >
                <div className="font-display italic text-blue" style={{ fontSize: "40px", fontWeight: 500 }}>
                  {c.n}
                </div>
                <h3 className="mt-4 text-navy text-[18px] font-bold">{c.title}</h3>
                <p className="mt-3 text-slate text-[14px] leading-relaxed">{c.body}</p>
                <span className="mt-5 inline-flex items-center gap-2 text-blue text-sm font-semibold group-hover:gap-3 transition-all">
                  Start <ArrowRight className="h-4 w-4" />
                </span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
